module.exports = __webpack_public_path__ + "img/title_pingxuan@2x.6618b809.png";